(function () {
    var $form = $('.contact form');

    if ($form.length === 0) return;

    // Form validation
    var options = {
        groupClass: 'has-error',
        groupSelector: '.form-group',
        errorPosClasses: ['.input-group', '.selectize-control'],
        helpSpanDisplay: 'help-block',
        delay: false,
        disableSubmitBtn: false,
    };

    var metrics = [
        ['input[name="name"]', 'presence', gmtrans('contact.frontend_validation.name_required')],
        ['input[name="email"]', 'presence', gmtrans('contact.frontend_validation.email_required')],
        ['select[name="enquiry"]', 'presence', gmtrans('contact.frontend_validation.enquiry_required')],
        ['textarea[name="comments"]', 'presence', gmtrans('contact.frontend_validation.comments_required')],
    ];

    $form.nod(metrics, options);
})();
